// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      display: block;
      font-family: 'DM Sans', 'Segoe UI', sans-serif;
    }

    /* ── Wrap ── */
    .empty-state-wrap {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 3.5rem 2rem;
      margin: 1.5rem;
      background: #ffffff;
      border-radius: 20px;
      border: 1.5px solid #f0eafa;
      box-shadow: 0 4px 32px rgba(109, 40, 217, 0.06);
      overflow: hidden;
    }

    /* ── Decorative blobs ── */
    .blob {
      position: absolute;
      border-radius: 50%;
      pointer-events: none;
      z-index: 0;
    }

    .blob-1 {
      width: 320px;
      height: 320px;
      top: -120px;
      right: -80px;
      background: radial-gradient(circle, rgba(167,139,250,0.12) 0%, transparent 70%);
    }

    .blob-2 {
      width: 240px;
      height: 240px;
      bottom: -80px;
      left: -60px;
      background: radial-gradient(circle, rgba(249,168,212,0.14) 0%, transparent 70%);
    }

    /* ── All content above blobs ── */
    .icon-ring, .es-title, .es-intro, .es-desc,
    .es-instructions, .video-btn, .es-divider,
    .es-cta-text, .es-action-btn {
      position: relative;
      z-index: 1;
    }

    /* ── Icon ring ── */
    .icon-ring {
      width: 88px;
      height: 88px;
      border-radius: 50%;
      background: linear-gradient(135deg, #f3eeff 0%, #fce7f3 100%);
      border: 2px solid #ede9fb;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 1.5rem;
      box-shadow: 0 4px 20px rgba(124, 58, 237, 0.12);
    }

    .icon-ring-inner {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      background: linear-gradient(135deg, #7c3aed 0%, #f97316 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 14px rgba(124, 58, 237, 0.3);
    }

    .icon-glyph {
      color: #ffffff;
    }

    /* ── Text ── */
    .es-title {
      font-size: 1.25rem;
      font-weight: 700;
      letter-spacing: -0.025em;
      color: #1a003d;
      margin: 0 0 0.75rem;
    }

    .es-intro {
      font-size: 0.9rem;
      font-weight: 500;
      color: #4b5563;
      margin: 0 0 0.375rem;
      max-width: 420px;
    }

    .es-desc {
      font-size: 0.85rem;
      color: #6b7280;
      font-weight: 400;
      margin: 0 0 1.5rem;
      max-width: 440px;
      line-height: 1.6;
    }

    /* ── Instructions ── */
    .es-instructions {
      background: #faf8ff;
      border: 1.5px solid #ede9fb;
      border-radius: 12px;
      padding: 1rem 1.25rem;
      margin-bottom: 1.5rem;
      max-width: 420px;
      width: 100%;
      text-align: left;
    }

    .es-inst-title {
      font-size: 0.75rem;
      font-weight: 700;
      color: #7c3aed;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin: 0 0 0.625rem;
    }

    .es-inst-list {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }

    .es-inst-item {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      font-size: 0.82rem;
      color: #4b5563;
      font-weight: 400;
      line-height: 1.5;
    }

    .inst-check {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: linear-gradient(135deg, #7c3aed, #f97316);
      color: white;
      flex-shrink: 0;
      margin-top: 1px;
    }

    /* ── Video button ── */
    .video-btn {
      display: inline-flex;
      align-items: center;
      gap: 0.625rem;
      padding: 0.625rem 1.5rem;
      border-radius: 100px;
      border: 1.5px solid #ede9fb;
      background: #faf8ff;
      color: #7c3aed;
      font-size: 0.82rem;
      font-weight: 600;
      cursor: pointer;
      margin-bottom: 1.5rem;
      transition: all 0.15s ease;
    }

    .video-btn:hover {
      background: #f3eeff;
      border-color: #c4b5fd;
      box-shadow: 0 2px 8px rgba(124, 58, 237, 0.12);
    }

    .video-play {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: linear-gradient(135deg, #7c3aed, #f97316);
      color: white;
      flex-shrink: 0;
    }

    /* ── Divider ── */
    .es-divider {
      width: 60%;
      height: 1px;
      background: linear-gradient(90deg, transparent, #f0eafa 30%, #f9d5ea 70%, transparent);
      margin: 0 0 1.25rem;
    }

    /* ── CTA text ── */
    .es-cta-text {
      font-size: 0.8rem;
      color: #9ca3af;
      font-weight: 400;
      margin: 0 0 1rem;
    }

    /* ── Action button ── */
    .es-action-btn {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.75rem 2rem;
      border-radius: 12px;
      border: none;
      background: linear-gradient(135deg, #7c3aed 0%, #f97316 100%);
      color: #ffffff;
      font-size: 0.9rem;
      font-weight: 700;
      cursor: pointer;
      letter-spacing: -0.01em;
      box-shadow: 0 4px 18px rgba(124, 58, 237, 0.3);
      transition: all 0.2s ease;
    }

    .es-action-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(124, 58, 237, 0.4);
    }

    .es-action-btn:active {
      transform: translateY(0);
    }

    /* ── Responsive ── */
    @media (max-width: 480px) {
      .empty-state-wrap {
        padding: 2.5rem 1.25rem;
        margin: 0.75rem;
      }

      .es-title { font-size: 1.1rem; }
      .icon-ring { width: 72px; height: 72px; }
      .icon-ring-inner { width: 52px; height: 52px; }
    }
  `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/units/zikata-empty-state/zikata-empty-state.component.ts"],"names":[],"mappings":";IACI;MACE,cAAc;MACd,8CAA8C;IAChD;;IAEA,eAAe;IACf;MACE,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,oBAAoB;MACpB,cAAc;MACd,mBAAmB;MACnB,mBAAmB;MACnB,2BAA2B;MAC3B,+CAA+C;MAC/C,gBAAgB;IAClB;;IAEA,2BAA2B;IAC3B;MACE,kBAAkB;MAClB,kBAAkB;MAClB,oBAAoB;MACpB,UAAU;IACZ;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,WAAW;MACX,YAAY;MACZ,+EAA+E;IACjF;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,aAAa;MACb,WAAW;MACX,+EAA+E;IACjF;;IAEA,kCAAkC;IAClC;;;MAGE,kBAAkB;MAClB,UAAU;IACZ;;IAEA,oBAAoB;IACpB;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,6DAA6D;MAC7D,yBAAyB;MACzB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,qBAAqB;MACrB,+CAA+C;IACjD;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,6DAA6D;MAC7D,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,8CAA8C;IAChD;;IAEA;MACE,cAAc;IAChB;;IAEA,eAAe;IACf;MACE,kBAAkB;MAClB,gBAAgB;MAChB,wBAAwB;MACxB,cAAc;MACd,mBAAmB;IACrB;;IAEA;MACE,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;MACd,oBAAoB;MACpB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA,uBAAuB;IACvB;MACE,mBAAmB;MACnB,2BAA2B;MAC3B,mBAAmB;MACnB,qBAAqB;MACrB,qBAAqB;MACrB,gBAAgB;MAChB,WAAW;MACX,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,cAAc;MACd,yBAAyB;MACzB,qBAAqB;MACrB,oBAAoB;IACtB;;IAEA;MACE,gBAAgB;MAChB,SAAS;MACT,UAAU;MACV,aAAa;MACb,sBAAsB;MACtB,WAAW;IACb;;IAEA;MACE,aAAa;MACb,uBAAuB;MACvB,WAAW;MACX,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,qDAAqD;MACrD,YAAY;MACZ,cAAc;MACd,eAAe;IACjB;;IAEA,uBAAuB;IACvB;MACE,oBAAoB;MACpB,mBAAmB;MACnB,aAAa;MACb,wBAAwB;MACxB,oBAAoB;MACpB,2BAA2B;MAC3B,mBAAmB;MACnB,cAAc;MACd,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,qBAAqB;MACrB,0BAA0B;IAC5B;;IAEA;MACE,mBAAmB;MACnB,qBAAqB;MACrB,8CAA8C;IAChD;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,qDAAqD;MACrD,YAAY;MACZ,cAAc;IAChB;;IAEA,kBAAkB;IAClB;MACE,UAAU;MACV,WAAW;MACX,sFAAsF;MACtF,mBAAmB;IACrB;;IAEA,mBAAmB;IACnB;MACE,iBAAiB;MACjB,cAAc;MACd,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA,wBAAwB;IACxB;MACE,oBAAoB;MACpB,mBAAmB;MACnB,WAAW;MACX,qBAAqB;MACrB,mBAAmB;MACnB,YAAY;MACZ,6DAA6D;MAC7D,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,uBAAuB;MACvB,8CAA8C;MAC9C,yBAAyB;IAC3B;;IAEA;MACE,2BAA2B;MAC3B,8CAA8C;IAChD;;IAEA;MACE,wBAAwB;IAC1B;;IAEA,qBAAqB;IACrB;MACE;QACE,uBAAuB;QACvB,eAAe;MACjB;;MAEA,YAAY,iBAAiB,EAAE;MAC/B,aAAa,WAAW,EAAE,YAAY,EAAE;MACxC,mBAAmB,WAAW,EAAE,YAAY,EAAE;IAChD","sourcesContent":["\n    :host {\n      display: block;\n      font-family: 'DM Sans', 'Segoe UI', sans-serif;\n    }\n\n    /* ── Wrap ── */\n    .empty-state-wrap {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      padding: 3.5rem 2rem;\n      margin: 1.5rem;\n      background: #ffffff;\n      border-radius: 20px;\n      border: 1.5px solid #f0eafa;\n      box-shadow: 0 4px 32px rgba(109, 40, 217, 0.06);\n      overflow: hidden;\n    }\n\n    /* ── Decorative blobs ── */\n    .blob {\n      position: absolute;\n      border-radius: 50%;\n      pointer-events: none;\n      z-index: 0;\n    }\n\n    .blob-1 {\n      width: 320px;\n      height: 320px;\n      top: -120px;\n      right: -80px;\n      background: radial-gradient(circle, rgba(167,139,250,0.12) 0%, transparent 70%);\n    }\n\n    .blob-2 {\n      width: 240px;\n      height: 240px;\n      bottom: -80px;\n      left: -60px;\n      background: radial-gradient(circle, rgba(249,168,212,0.14) 0%, transparent 70%);\n    }\n\n    /* ── All content above blobs ── */\n    .icon-ring, .es-title, .es-intro, .es-desc,\n    .es-instructions, .video-btn, .es-divider,\n    .es-cta-text, .es-action-btn {\n      position: relative;\n      z-index: 1;\n    }\n\n    /* ── Icon ring ── */\n    .icon-ring {\n      width: 88px;\n      height: 88px;\n      border-radius: 50%;\n      background: linear-gradient(135deg, #f3eeff 0%, #fce7f3 100%);\n      border: 2px solid #ede9fb;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 1.5rem;\n      box-shadow: 0 4px 20px rgba(124, 58, 237, 0.12);\n    }\n\n    .icon-ring-inner {\n      width: 64px;\n      height: 64px;\n      border-radius: 50%;\n      background: linear-gradient(135deg, #7c3aed 0%, #f97316 100%);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: 0 4px 14px rgba(124, 58, 237, 0.3);\n    }\n\n    .icon-glyph {\n      color: #ffffff;\n    }\n\n    /* ── Text ── */\n    .es-title {\n      font-size: 1.25rem;\n      font-weight: 700;\n      letter-spacing: -0.025em;\n      color: #1a003d;\n      margin: 0 0 0.75rem;\n    }\n\n    .es-intro {\n      font-size: 0.9rem;\n      font-weight: 500;\n      color: #4b5563;\n      margin: 0 0 0.375rem;\n      max-width: 420px;\n    }\n\n    .es-desc {\n      font-size: 0.85rem;\n      color: #6b7280;\n      font-weight: 400;\n      margin: 0 0 1.5rem;\n      max-width: 440px;\n      line-height: 1.6;\n    }\n\n    /* ── Instructions ── */\n    .es-instructions {\n      background: #faf8ff;\n      border: 1.5px solid #ede9fb;\n      border-radius: 12px;\n      padding: 1rem 1.25rem;\n      margin-bottom: 1.5rem;\n      max-width: 420px;\n      width: 100%;\n      text-align: left;\n    }\n\n    .es-inst-title {\n      font-size: 0.75rem;\n      font-weight: 700;\n      color: #7c3aed;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      margin: 0 0 0.625rem;\n    }\n\n    .es-inst-list {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n\n    .es-inst-item {\n      display: flex;\n      align-items: flex-start;\n      gap: 0.5rem;\n      font-size: 0.82rem;\n      color: #4b5563;\n      font-weight: 400;\n      line-height: 1.5;\n    }\n\n    .inst-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 18px;\n      height: 18px;\n      border-radius: 50%;\n      background: linear-gradient(135deg, #7c3aed, #f97316);\n      color: white;\n      flex-shrink: 0;\n      margin-top: 1px;\n    }\n\n    /* ── Video button ── */\n    .video-btn {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.625rem;\n      padding: 0.625rem 1.5rem;\n      border-radius: 100px;\n      border: 1.5px solid #ede9fb;\n      background: #faf8ff;\n      color: #7c3aed;\n      font-size: 0.82rem;\n      font-weight: 600;\n      cursor: pointer;\n      margin-bottom: 1.5rem;\n      transition: all 0.15s ease;\n    }\n\n    .video-btn:hover {\n      background: #f3eeff;\n      border-color: #c4b5fd;\n      box-shadow: 0 2px 8px rgba(124, 58, 237, 0.12);\n    }\n\n    .video-play {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 28px;\n      height: 28px;\n      border-radius: 50%;\n      background: linear-gradient(135deg, #7c3aed, #f97316);\n      color: white;\n      flex-shrink: 0;\n    }\n\n    /* ── Divider ── */\n    .es-divider {\n      width: 60%;\n      height: 1px;\n      background: linear-gradient(90deg, transparent, #f0eafa 30%, #f9d5ea 70%, transparent);\n      margin: 0 0 1.25rem;\n    }\n\n    /* ── CTA text ── */\n    .es-cta-text {\n      font-size: 0.8rem;\n      color: #9ca3af;\n      font-weight: 400;\n      margin: 0 0 1rem;\n    }\n\n    /* ── Action button ── */\n    .es-action-btn {\n      display: inline-flex;\n      align-items: center;\n      gap: 0.5rem;\n      padding: 0.75rem 2rem;\n      border-radius: 12px;\n      border: none;\n      background: linear-gradient(135deg, #7c3aed 0%, #f97316 100%);\n      color: #ffffff;\n      font-size: 0.9rem;\n      font-weight: 700;\n      cursor: pointer;\n      letter-spacing: -0.01em;\n      box-shadow: 0 4px 18px rgba(124, 58, 237, 0.3);\n      transition: all 0.2s ease;\n    }\n\n    .es-action-btn:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 8px 24px rgba(124, 58, 237, 0.4);\n    }\n\n    .es-action-btn:active {\n      transform: translateY(0);\n    }\n\n    /* ── Responsive ── */\n    @media (max-width: 480px) {\n      .empty-state-wrap {\n        padding: 2.5rem 1.25rem;\n        margin: 0.75rem;\n      }\n\n      .es-title { font-size: 1.1rem; }\n      .icon-ring { width: 72px; height: 72px; }\n      .icon-ring-inner { width: 52px; height: 52px; }\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
